import moment from 'moment-timezone';
import Request from 'files/Request.js';
import User from 'classes/User.js';

class OutboundCallClass {

    appointment_id = null;
    call_sid = null;
    created_at = null;
    duration = null;
    from_number = null;
    lead_id = null;
    lead_full_name = null;
    lead_status_text = null;
    id = null;
    metadata = null;
    provider = null;
    recording_url = null;
    status = null;
    to_number = null;
    updated_at = null;
    user = null;
    user_id = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.appointment_id = props.appointment_id;
        this.call_sid = props.call_sid;
        this.created_at = props.created_at && moment.utc(props.created_at).local();
        this.duration = props.duration;
        this.from_number = props.from_number;
        this.lead_full_name = props.lead_full_name;
        this.lead_id = props.lead_id;
        this.lead_status_text = props.lead_status_text;
        this.id = props.id;
        this.metadata = props.metadata;
        this.provider = props.provider;
        this.recording_url = props.recording_url;
        this.status = props.status;
        this.to_number = props.to_number;
        this.updated_at = props.updated_at && moment.utc(props.updated_at).local();
        this.user = props.user && User.create(props.user);
        this.user_id = props.user_id;
        return this;
    }
}

const fetchCall = async (utils, id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { outbound_call } = await Request.get(utils, '/clients/', {
                type: 'outbound_call_details',
                id: id
            });
            let obj = new OutboundCallClass().create(outbound_call);
            resolve(obj);

        } catch(e) {
            reject(e);
        }
    })
}

export default {
    create: props => new OutboundCallClass().create(props),
    get: (utils, id) => fetchCall(utils, id),
    new: () => new OutboundCallClass()
}
